import { useState } from 'react';

export const useGeosuggestSelector = (countryInitValue) => {
  const [typedGeoValue, setTypedGeoValue] = useState(null);
  const [selectedGeoValue, setSelectedGeoValue] = useState(countryInitValue);

  const onTypeGeoValue = (value) => {
    setTypedGeoValue(value);
  };

  const onSelectGeoValue = (value) => {
    setSelectedGeoValue(value);
    if (value) {
      setTypedGeoValue(null);
    }
  };

  return {
    typedGeoValue,
    selectedGeoValue,
    onTypeGeoValue,
    onSelectGeoValue,
  };
};
